import {StyleSheet, PixelRatio} from 'react-native';

export default StyleSheet.create({
    filterLayer:{
        height: 'auto',
        paddingBottom: 70
    },
    filterModalWrapper:{
        height: 50,
        marginLeft: 24,
        justifyContent: 'center'
    },
    border:{
        width: '200%',
        height: 1,
        transform:[{scaleX: 0.5}, {scaleY: 0.5}],
        backgroundColor:'#e6e6e6',
        position:'absolute',
        transformOrigin:'left',
        left:0,
        bottom:0
    },
    filterModalText:{
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 4
    },
    filterItemAfterText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        color: "#999999"
    },
    filterModalItem:{
        flexDirection: 'row',
        marginRight: 24,
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    filterItemText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 16,
        color: "#333333"
    },
    filterItemActiveText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 16,
        color: "#00CAD8"
    },
    checkIcon: {
        height: 20,
        lineHeight: 20,
        color: '#00CAD8',
        fontFamily: 'low_price_rn',
        fontSize: 20
    }

});